import { Component, OnInit } from '@angular/core';
import { StoreService } from 'src/app/store.service';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-emailSetting',
  templateUrl: './email-setting.component.html',
  styleUrls: ['./email-setting.component.scss']
})
export class EmailSettingComponent implements OnInit {

  closeResult = '';
  bearer;

  store_id;
  discounts = [] ;
  discount_id =[];
  voucherList = [];

  success;
  
  productNameFilter;
  countryFilters = [];
  statusFilters = []
  selectedStatus 

  templates

  clickEventsubscription: Subscription;
  loading = true;

  constructor(
    private storeService: StoreService,
    private modalService: NgbModal,
    private router: Router
  ) {
    // Change store_id accordingly
    this.clickEventsubscription = storeService.getClickEvent().subscribe(()=>{
      const store_id = localStorage.getItem('store_id');
      if(store_id) {
        this.store_id = parseInt(store_id);
      }
    })
  }

  ngOnInit(): void {
    // Change template based on store_id
    const store_id = localStorage.getItem('store_id');
    this.bearer = localStorage.getItem('bearer');

    if(store_id) {
      this.store_id = parseInt(store_id);
    }
    
    this.getTemplate();
  }

  getTemplate() {
    // this.storeService.getEmailTemplates(this.bearer,this.store_id).subscribe(res => {
    this.storeService.getEmailTemplates(this.bearer).subscribe(res => {
      console.log(res);
      this.templates = res['data'];
      console.log('templates',this.templates);
      
      // this.sliceCart();
      this.loading = false;
    })
  }

  open(content, id) {
    this.modalService.open(content, {
      ariaLabelledBy: 'modal-basic-title',
      centered: true,
      backdrop: 'static'
    }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
      console.log(result);
      console.log(id);
      if(result == 'delete') {
        this.deleteDiscount(id);
      }
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  successModal(success) {
      this.modalService.open(
          success, {
              ariaLabelledBy: 'modal-basic-title',
              size: 'sm',
              windowClass: 'modal-success',
              centered: true,
              backdrop: 'static'
          }).result.then((result) => {
          this.closeResult = `Closed with: ${result}`;
          // location.reload();
          this.modalService.dismissAll();

      }, (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
          //location.reload();
          this.modalService.dismissAll();
      });
      //location.reload();
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  deleteDiscount(id: number) {
    // // remove discount id in array
    // if (this.discount_id.includes(id)) {
    //   this.discount_id.splice(this.discount_id.indexOf(id), 1); 
    // }

    // const curr_ids = this.discount_id.join(","); 

    // const params = {
    //   store_id:this.store_id.toString(),
    //   discount_id: curr_ids.length != 0 ? curr_ids : [0]
    // };
    // console.log(params);
    // this.storeService.updateStoreDiscount(params, this.bearer).subscribe(res=>{
    //   console.log(res['status']);

    //   if(res['status'] == 'success') {
    //     this.getStoreDiscount();
    //     this.getDiscountList();
    //     this.discount_id =[];
    //     /*
    //     this.toastSuccessMsg = 'Discount deleted successfully!'
    //     this.toastSuccess = true;
    //     setTimeout(()=>{
    //       if(this.toastSuccess) this.toastSuccess = false;
    //     },3000)
    //     */
    //   }
    //   else {
    //     /*
    //     this.toastErrorMsg = 'Discount delete failed!';
    //     this.toastError = true;
    //     setTimeout(()=>{
    //       if(this.toastError) this.toastError = false;
    //     },3000)
    //     */
    //   }
    // },(err)=>{
    //   /*
    //   this.toastErrorMsg = 'Discount delete failed!';
    //     this.toastError = true;
    //     setTimeout(()=>{
    //       if(this.toastError) this.toastError = false;
    //     },3000)
    //     */
    //   this.discount_id = [];
    // })
  }

}
